// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39JFz","title":"styles_title__1QY7g"};